// extracted by mini-css-extract-plugin
module.exports = {"globalSpinner":"_globalSpinner--3ziMe","spinner":"_spinner--3uBXS"};